import { CampaignOutlined } from "@mui/icons-material";
import AnnouncementBanner from "./common/AnnouncementBanner";

export default function AssetRetrievalsCanncellationAnnouncementBanner() {
  return (
    <AnnouncementBanner
      title="We have an update - you will be able to cancel an order after it's placed."
      description="You can cancel orders directly from the list below."
      icon={<CampaignOutlined fontSize="large" sx={{ color: "#ed7823", verticalAlign: "middle" }} />}
      overrideProps={{
        iconContainer: {
          sx: {
            background: "#FFE3B8",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 49,
            height: 49,
          },
        },
      }}
    />
  );
}
